var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirImp7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.825 11.084l-2.406-2.926a.318.318 0 00-.246-.116h-6.317a.318.318 0 00-.246.116l-2.406 2.926a.287.287 0 00-.068.186v8.224a.31.31 0 00.315.302h11.124a.31.31 0 00.315-.302V11.27a.272.272 0 00-.066-.186zm-.856-.066h-4.64V8.646h2.691l1.95 2.372zm-7.96-2.372h2.69v2.372H9.06l1.95-2.372zM8.765 19.192v-7.57H19.26v7.57H8.766z",
    fill: "#2B2B2B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.013,
    cy: 13.301,
    r: 12.801,
    stroke: "#2B2B2B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.043,
    cy: 4.949,
    r: 4.949,
    fill: "#EEF0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.402 6.806h-2.26V2.83h2.26v.596H2.854v1.013H4.3v.596H2.854v1.17h1.548v.6zM5.83 5.263l-.996-1.475h.796l.657 1.024.657-1.024h.796L6.732 5.263 7.79 6.806h-.796l-.707-1.097-.707 1.097h-.796L5.83 5.263zm4.873 12.059V14.23h.554v2.624h1.29v.468h-1.844zm3.613-2.668c-.283 0-.503.101-.659.303-.153.202-.23.477-.23.823 0 .35.073.624.217.823.145.196.367.294.667.294.13 0 .257-.013.381-.038.125-.03.255-.067.39-.113v.472c-.127.052-.255.09-.385.113a2.492 2.492 0 01-.442.034c-.318 0-.58-.065-.788-.195a1.199 1.199 0 01-.463-.554 2.15 2.15 0 01-.152-.84c0-.312.056-.586.169-.823a1.3 1.3 0 01.493-.563c.22-.136.487-.204.802-.204.156 0 .309.02.459.057.153.034.296.083.428.147l-.19.455a3.236 3.236 0 00-.342-.13 1.068 1.068 0 00-.355-.06zm1.432 2.668V14.23h.554v2.624h1.29v.468h-1.844z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirImp7);
export default __webpack_public_path__ + "static/media/air_imp_7.51c9e0d6d7578bb3beddd1e031b79e5f.svg";
export { ForwardRef as ReactComponent };